// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Gmqq","colBig":"styles_colBig__2l0QJ","colSmall":"styles_colSmall__3n7yD","shopifyNameWrapper":"styles_shopifyNameWrapper__3EUC9"};